import { ResourcesCard } from "./ResourcesCard"

export const FeaturedResources = ({ resources }) => {
  return <ResourcesCard resources={resources} />
}
